import grassImg from "../assets/flowers/grass.png";
import grassPlumeImg from "../assets/flowers/grass-plume.png";
import grassSpikeImg from "../assets/flowers/grass-spike.png";
import korenbloemImg from "../assets/flowers/korenbloem.png";
import madeliefImg from "../assets/flowers/madelief.png";
import rudbeckiaImg from "../assets/flowers/rudbeckia.png";

export const BLOOM_FLOWER_IMAGES = [rudbeckiaImg, madeliefImg, korenbloemImg] as const;
export const BLOOM_GRASS_IMAGES = [grassImg, grassSpikeImg, grassPlumeImg] as const;

export const FLOWER_IMAGES = [...BLOOM_FLOWER_IMAGES, ...BLOOM_GRASS_IMAGES] as const;

const FLOWER_COUNT = BLOOM_FLOWER_IMAGES.length;
/** Gras z-index 0–~550; bloemen altijd daarboven. */
const FLOWER_Z_OFFSET = 600;

export interface FlowerPlacement {
  leftPercent: number;
  rotateDeg: number;
  scale: number;
  mirror: boolean;
  imageIndex: number;
  zIndex: number;
}

/** Deterministic pseudo-random placement — stable across re-renders. */
export function placementForFlower(index: number): FlowerPlacement {
  let s = (index + 1) * 7919 + 104729;
  const rand = () => {
    s = (s * 1664525 + 1013904223) >>> 0;
    return s / 0xffffffff;
  };

  const scale = 0.55 + rand() * 0.45;
  const imageIndex = Math.floor(rand() * FLOWER_IMAGES.length);
  const isGrass = imageIndex >= FLOWER_COUNT;
  const depthLayer = Math.round((1 - scale) * 500) + index;

  return {
    leftPercent: rand() * 100,
    rotateDeg: -18 + rand() * 36,
    scale,
    mirror: rand() > 0.5,
    imageIndex,
    zIndex: isGrass ? depthLayer : depthLayer + FLOWER_Z_OFFSET,
  };
}

if (import.meta.env.DEV) {
  const sample = placementForFlower(3);
  if (
    sample.leftPercent < 0 ||
    sample.leftPercent > 100 ||
    sample.scale <= 0 ||
    sample.imageIndex < 0 ||
    sample.imageIndex >= FLOWER_IMAGES.length
  ) {
    throw new Error("placementForFlower: invalid sample");
  }

  if (FLOWER_Z_OFFSET <= 500) {
    throw new Error("FLOWER_Z_OFFSET must keep grass behind flowers");
  }
}
